module.exports = __webpack_public_path__ + "img/side-add.9bb5ee2f.png";